// eslint-no-undef
import React from 'react';
import '../App.css';
import TimeAgo from 'react-timeago';
import editButton from '../images/edit_button.png';
import editButtonHover from '../images/edit_button_hover.png';
import {ellipses} from '../Helpers';
import ProfileImageUploader from './ProfileImageUploader';
import InviteModal from './InviteModal';
import {updateUserInfo} from '../Helpers';
import ItemEditor from './ItemEditor';
import Item from './Item';

const baseUrl = window.location.protocol + '//' + window.location.host;

export default class Profile extends React.Component {

  showPost(e, post) {
    e.preventDefault();
    let that = this;
    fetch(`/api/v1/posts/${post._id['$oid']}?include_comments=true&include_stats=true`, function(err, data) {
      if (err) {
        console.log('Error fetching post id ' + post._id['$oid']);
      } else {
        // We can haz data.
        let postData = JSON.parse(data.body)['posts'];
        that.props.app.showPost(postData);
      }
    });
  }

  showInviteModal(event) {
    event.preventDefault();
    this.props.app.setState({modal: <InviteModal app={this.props.app} user={this.props.user} />});
  }

  componentDidMount() {
    console.log('[Profile] componentWillReceiveProps fired...');
    window.scrollTo(0, 0);
  }

  constructor(props) {
    super(props);
    this.state = {
      editButton: editButton,
      username: this.props.user.username,
      summary: this.props.user.summary,
      activityData: [],
    };
    if (this.props && this.props.user) {
      console.log('Profile component has user...');
      // Always fetch...
      if (this.props && this.props.user) {
        let that = this;
        fetch(`/api/v1/users/${this.props.user._id['$oid']}?include_area=true&include_counts=true&include_activity=true`, function(err, data) {
          console.log('Got user data: ' + JSON.stringify(data));
          if (err) {
            console.log('Got error fetching user data: ' + err);
          } else {
            let userData = JSON.parse(data.body)['users'];
            let activityData = [];
            let postArray = userData['activity'];
            for (let i = 0; i < postArray.length; i++) {
              activityData.push(
                <div key={postArray[i]._id['$oid']} onClick={(e) => that.showPost(e, postArray[i])} className='activityRow'>
                  {postArray[i].title ? ellipses(postArray[i].title, 50) : ellipses(postArray[i].text, 50)}
                  <br />
                  <span className='timeAgo'><TimeAgo date={postArray[i].created_at} /></span>
                </div>
              );
            }
            let availableInvites = ( 10 - userData.invite_count );
            that.setState({
              areaName: userData.area.name,
              postCount: userData.post_count,
              commentCount: userData.comment_count,
              activityData: activityData,
              availableInvites: availableInvites,
            });
          }
        });
      }
    }
  }

  submitEdit() {
    console.log('Submitting user profile update...');
    let updateData = {
      username: this.state.username,
      summary: this.state.summary,
    };
    if (this.uploadedStringImage) {
      updateData['uploadedStringImage'] = this.uploadedStringImage;
    }
    updateUserInfo(this.props.app, updateData);
    this.setState({editing: false});
  }

  handleMouseOver() {
    this.setState({editButton: editButtonHover});
  }

  handleMouseOut() {
    this.setState({editButton: editButton});
  }

  showImageUploader(event) {
    event.preventDefault();
    this.setState({showImageUploader: true, editing: true});
    console.log('Clicked camera button...');
  }

  hideImageUploader(event) {
    console.log('Hiding image uploader...');
    if (event) {
      event.preventDefault();
    }
    this.setState({showImageUploader: false});
  }

  setEditing(event) {
    event.preventDefault();
    this.setState({editing: true});
  }

  updateSummary(data) {
    this.setState({summary: data});
  }

  showConversations(e, username) {
    this.props.app.showConversations(e, username);
  }

  setEditingItem(itemId) {
    if (this.props.user && this.props.user.inventory && this.props.user.inventory.length > 0) {
      for (let i = 0; i < this.props.user.inventory.length; i++) {
        let checkItem = this.props.user.inventory[i];
        if (checkItem._id === itemId) {
          this.setState({editingItem: checkItem, showItemEditor: true});
        }
      }
    }
  }

  render() {
    let joined = new Date(this.props.user.created_at).toString().split(' ').splice(0, 3).join(' ');
    let previewImage = '', submitButton = '', areaName = '', role = '';
    if (this.props.user && this.props.user.area) {
      areaName = this.props.user.area.name;
    } else if (this.state.areaName) {
      areaName = this.state.areaName;
    }
    let editButton = '', avatarImage = '', summary = '';
    if (this.props.user._id['$oid'] === this.props.currentUser._id['$oid']) {
      // This profile belongs to the currently logged in user. Enable edit button.
      editButton = <img className='editButton' style={{width: '20px', marginRight: '6px'}}
                    src={this.state.editButton} alt='Edit'
                    onMouseOut={(e) => this.handleMouseOut(e)}
                    onMouseOver={(e) => this.handleMouseOver(e)}
                    onClick={(e) => this.setEditing(e)} />;
      submitButton = <button className='profileSubmitButton' onClick={() => this.submitEdit()}>Update</button>;
      avatarImage = <img className='avatarFull' src={this.props.user.avatar} alt={this.props.user.username}
                     onClick={(e) => this.showImageUploader(e)} />;
    } else {
      avatarImage = <img className='avatarFull' src={this.props.user.avatar} alt={this.props.user.username} />;
    }
    if (this.state.editing) {
      summary = <textarea className='profileSummary' rows={6} size={8}
                          onChange={(e) => this.updateSummary(e.target.value)}
                          value={this.state.summary || ''} />;
    } else {
      summary = this.state.summary || this.props.user.summary;
    }
    if (this._imageUploader && this._imageUploader.state && this._imageUploader.state.binFile) {
       this.uploadedImage = this._imageUploader.state.imgFile;
       this.uploadedStringImage = this._imageUploader.state.binFile.toDataURL();
    }
    if (this._imageUploader && this._imageUploader.state && this._imageUploader.state.binFile) {
      previewImage = <img className='avatarFull' src={this.uploadedStringImage} alt={this.props.user.username} width={120} />;
      this.setState({previewImage: previewImage});
    }
    if (this.props.user.role) {
      if (this.props.user.role.name === 'Fundador') {
        role = <font className='fundadorRoleLabel'>{this.props.user.role.name}: </font>;
      } else if (this.props.user.role.name === 'Moderador') {
        role = <font className='moderadorRoleLabel'>{this.props.user.role.name}: </font>;
      } else {
        role = <b>{this.props.user.role.name}: </b>;
      }
    }
    let inventoryDiv = '';
    if (this.props.user.inventory && this.props.user.inventory.length > 0) {
      inventoryDiv = [];
      for (let i = 0; i < this.props.user.inventory.length; i++) {
        let item = this.props.user.inventory[i];
        if (this.state.editingItem && this.state.editingItem._id.$oid === item._id.$oid) {
          inventoryDiv.push(<ItemEditor user={this.props.user} viewPage={this} item={item} />);
        } else {
          inventoryDiv.push(
            <Item setEditingItem={(itemId) => this.setEditingItem(itemId)} itemId={item._id} itemDescription={item.description}
                  itemValue={item.value} itemSerial={item.serial} itemAssetTag={item.asset_tag} itemName={item.name}
                  itemImage={item.image_url} itemPrivate={item.private} itemLabels={item.labels} />
          );
        }
      }
    }
    return (
      <div className='timeline'>
        { this.state.showImageUploader ? <ProfileImageUploader finish={this.hideImageUploader.bind(this)} ref={(ref) => this._imageUploader = ref}  /> : '' }
        <div className='timelineInner'>
          <div className='post' style={{height: '140px', padding: '0px', paddingLeft: '12px'}}>
            <div className='profileHeader'>
              {this.state.previewImage || avatarImage}
              <div className='profileHeaderText' style={{marginLeft: '10px'}}>
                <font className='postTitleText'>{this.props.user.first_name} {this.props.user.last_name}</font>
                &nbsp;(<font className='genericLabel'>{this.props.user.username}</font>)
                <p />
                {role}
                <b>{areaName}</b>
                <br />
                <i><b>{this.props.user.points}</b> pontos de influência</i>
                <br />
                Ingressou {joined}
                <p />
                <span className='fakeLink' onClick={(e) => this.showInviteModal(e)}>{this.state.availableInvites || 0} convites disponíveis</span>
              </div>
              {this.props.user.username !== this.props.currentUser.username ?
                   <input type='button' className='postSubmitButton'
                          style={{float: 'right', position: 'relative', right: '10px', width: '96px',  bottom: '22px'}}
                          onClick={(e) => this.showConversations(e, this.props.user.username)} value='Mensagem' />
               : ''}
            </div>
          </div>
          <div className='post'>
            <div className='profileHeader' style={{marginTop: '0px', paddingBottom: '6px'}}>
              {editButton}
              <font className='genericLabel'>ABOUT ME</font>
              <br /><p />
              {summary}
            </div>
          </div>
          {this.state.editing ? submitButton : ''}
          <div className='post'>
            <div className='profileHeader' style={{marginTop: '4px'}}>
              <font className='genericLabel'>ACTIVITY</font>
              <div className='rightFloatText' style={{top: '0px'}}>
                {this.state.postCount || this.props.user.post_count || 0} posts
                &nbsp;&nbsp;
                {this.state.commentCount || this.props.user.comment_count || 0} comments
              </div>
              <br /><p />
              {this.state.activityData}
            </div>
          </div>
          <div className='post' style={{marginTop: '10px', padding: '0px'}}>
            <div style={{padding: '8px'}}><span className='genericLabel'>&nbsp;INVENTARIO</span> <span className='fakeLink' onClick={() => this.setState({showItemEditor: true})}>[+]</span></div>
            {(this.state.showItemEditor && !this.state.editingItem) ? <ItemEditor user={this.props.user} viewPage={this} item={this.state.editingItem} /> : ''}
            <div style={{'padding-top': '8px'}}>
               {inventoryDiv}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
